import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { VbFlickityCarouselComponent } from 'rev-shared/ui/flickityCarousel/VbFlickityCarousel.Component';

import { InThisVideoAngularModule } from 'rev-portal/media/videos/videoPlayback/inThisVideo/InThisVideoAngular.Module';

import { PulseInVideoCarouselComponent } from './PulseInVideoCarousel.Component';
import { VideoPulseContainerComponent } from './VideoPulseContainer.Component';
import { PulseModule } from './Pulse.Module';
import { PulseCarouselEntryOrderDirective } from './PulseCarouselEntryOrder.Directive';

@NgModule({
	declarations: [
		PulseCarouselEntryOrderDirective,
		PulseInVideoCarouselComponent,
		VideoPulseContainerComponent
	],
	exports: [
		VideoPulseContainerComponent
	],
	imports: [
		CommonModule,
		InThisVideoAngularModule,
		PulseModule,
		TooltipModule,
		TranslateModule,
		VbFlickityCarouselComponent
	]
})
export class VideoPulseModule { }
